import { SvgIcon, SvgIconProps } from '@mui/material'

const Map = (props: SvgIconProps) => {
  return (
    <SvgIcon role="img" viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.596 2.368a.75.75 0 0 1 .718-.049l6.197 2.86 6.694-2.868a.75.75 0 0 1 .61.008l6.5 3A.75.75 0 0 1 22.75 6v15a.75.75 0 0 1-1.064.681l-6.197-2.86-6.694 2.868a.75.75 0 0 1-.61-.008l-6.5-3A.75.75 0 0 1 1.25 18V3a.75.75 0 0 1 .346-.632Zm13.893 1.453L8.795 6.689a.75.75 0 0 1-.61-.008L2.75 4.172V17.52l5.761 2.66 6.694-2.87a.75.75 0 0 1 .61.009l5.435 2.509V6.48l-5.761-2.66Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.5 2.25a.75.75 0 0 1 .75.75v15a.75.75 0 0 1-1.5 0V3a.75.75 0 0 1 .75-.75ZM8.5 5.25a.75.75 0 0 1 .75.75v15a.75.75 0 0 1-1.5 0V6a.75.75 0 0 1 .75-.75Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.205 2.31a.75.75 0 0 1 .61.009l3.25 1.5a.75.75 0 0 1-.63 1.362l-2.946-1.36-6.693 2.868a.75.75 0 0 1-.61-.008l-3.25-1.5a.75.75 0 1 1 .628-1.362l2.947 1.36 6.694-2.868ZM15.205 17.31a.75.75 0 0 1 .61.009l3.25 1.5a.75.75 0 0 1-.63 1.362l-2.946-1.36-6.693 2.868a.75.75 0 0 1-.61-.008l-3.25-1.5a.75.75 0 0 1 .628-1.362l2.947 1.36 6.694-2.868Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export default Map
